<template>
  <b-modal
    id="modal-scrollable"
    v-model="$store.state.someVariables.showConfigResetTa"
    no-close-on-backdrop
    scrollable
    :title="
      `Config. Reset Amarillas ${categoria.disciplina} ${categoria.categoria}`
    "
    cancel-variant="outline-secondary"
    ok-only
    @hidden="onlyClose"
  >
    <span :class="campeonato.activo === 's' ? 'camp-activo' : 'camp-anterior'"
      >Campeonato Activo: #{{ campeonato.id_campeonato }} temporada
      {{ campeonato.anio_inic }} -
      {{ campeonato.anio_fin }}
    </span>
    <div class="mt-2 mb-1">
      Deseo que las tarjetas amarillas empiecen en 0 desde la etapa:
    </div>
    <b-overlay :show="showLoading" rounded="sm">
      <b-row v-for="item in listEtapas" :key="item.id">
        <b-col v-if="idReset === null">
          <b-form-radio
            v-model="radioSelected"
            name="some-radios"
            :value="item.etapa"
          >
            <small> Etapa {{ item.etapa }} </small>
          </b-form-radio>
        </b-col>
        <b-col v-else>
          <p style="font-size:13px;font-weight: bolder">
            Etapa {{ item.etapa }}
          </p>
        </b-col>
      </b-row>
      <br />
      <template v-if="listCambios.length != 0">
        <div style="font-size:10px;font-weight: bolder">Control de Cambios</div>
        <div
          style="background:#f5f5f5; margin-top:3px; padding:3px"
          v-for="item in listCambios"
          :key="item.id"
        >
          <span style="font-size:10px"
            >{{ item.fecha }} {{ item.usuario_edita }} {{ item.accion }}</span
          >
        </div>
      </template>
    </b-overlay>
    <template #modal-footer>
      <div class="w-100">
        <template>
          <b-button
            v-if="
              USER().rol === `${ROLES.ADMIN}` ||
                USER().rol === `${ROLES.SUPER}` ||
                USER().rol === ROLES.TECNICA
            "
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :variant="idReset !== null ? 'danger' : 'primary'"
            class="float-right"
            @click="saveDelete()"
          >
            <span>{{ idReset !== null ? 'Eliminar' : 'Guardar' }}</span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="float-right mr-1"
            @click="onlyClose"
          >
            Cancelar
          </b-button>
        </template>

        <b-alert
          :show="dismissCountDown"
          v-height-fade.appear
          :variant="variante"
          style="position:absolute; bottom:55px;  width:92%; margin-left:-4px"
          @dismiss-count-down="countDownChanged"
        >
          <div
            :class="{
              'alert-body danger': variante == 'danger',
              'alert-body success': variante == 'success',
            }"
          >
            {{ messageError }}
          </div>
        </b-alert>
      </div>
    </template>
  </b-modal>
</template>
<script>
import {
  BModal,
  BButton,
  BAlert,
  BOverlay,
  BFormRadio,
  BRow,
  BCol,
  // xx
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import { heightFade } from '@core/directives/animations'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  ROLES,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
  //   ESTADO_JUGADOR,
} from '../../utils/variables'

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    BOverlay,
    BFormRadio,
    BRow,
    BCol,
  },
  props: {
    listEtapas: Array,
    listCambios: Array,
    categoria: Object,
    campeonato: Object,
    idReset: String,
  },
  directives: {
    Ripple,
    heightFade,
  },
  setup(props, { emit }) {
    const listOpciones = ref([])
    const etapaSelected = ref([])
    const messageError = ref('')
    const variante = ref('danger')
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const hasError = ref(false)
    const showLoading = ref(false)
    const radioSelected = ref(props.idReset)
    const idConfig = ref(null)
    const totalGrupos = ref(0)
    const campeonatoSeleccionado = ref({
      label: 'Seleccione campeonato',
      value: null,
    })
    const { postApi } = apiCall()
    function showMessageAlert(type, mensaje) {
      variante.value = type
      hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }

    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function reset() {
      radioSelected.value = null
      // etapaSelected.value = []
      countDownChanged(0)
    }
    async function insertConfiguration() {
      // console.log(props.categoria)

      const path = 'ApiConfiguration/insertConfigResetTa'
      const dataSend = {
        rol: USER().rol,
        id_campeonato: props.campeonato.id_campeonato,
        id_categoria: props.categoria.id_categoria,
        etapa: radioSelected.value,
        id_usuario: USER().id_usuario,
        id_torneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        movimiento: `Agrega restricción para tarjetas amarillas, categoria ${props.categoria.disciplina} ${props.categoria.categoria} etapa # ${radioSelected.value} `,
      }

      if (radioSelected.value === null) {
        showMessageAlert('danger', 'Seleccione una etapa')
        return
      }
      //   rol, id_jugador, id_equipo, num_camiseta
      const response = await postApi(URL, path, dataSend)
      // console.log(response)
      if (response.flag === 'si') {
        showMessageAlert('success', 'Configuración creada exitosamente')
        // console.log('si')
        props.categoria.tiene_reset_amarillas = true
        emit('exitoTa', props.categoria)
        reset()
      } else {
        showMessageAlert('danger', response.mensaje)
      }
    }
    async function deleteConfiguration() {
      showLoading.value = true
      const path = 'ApiConfiguration/deleteConfigResetTa'
      const dataSend = {
        id_usuario: USER().id_usuario,
        id_reset_amarilla: props.idReset,
        id_campeonato: props.campeonato.id_campeonato,
        id_categoria: props.categoria.id_categoria,
        id_torneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        movimiento: `Elimina restricción para tarjetas amarillas, categoria ${props.categoria.disciplina} ${props.categoria.categoria} etapa # ${radioSelected.value} `,
      }
      //   rol, id_jugador, id_equipo, num_camiseta
      const response = await postApi(URL, path, dataSend)
      // console.log(response)
      if (response.flag === 'si') {
        showMessageAlert('success', 'Configuración eliminada exitosamente')
        props.categoria.tiene_reset_amarillas = false
        emit('exitoTa', props.categoria)
        reset()
      } else {
        showMessageAlert('danger', response.mensaje)
      }
      showLoading.value = false
    }
    function saveDelete() {
      showMessageAlert('success', 'Configuración creada exitosamente')

      if (props.idReset !== null) {
        deleteConfiguration()
      } else {
        insertConfiguration()
      }
    }

    function onlyClose() {
      campeonatoSeleccionado.value = null
      listOpciones.value = []
      showLoading.value = false
      idConfig.value = null
      totalGrupos.value = 0
      reset()
      store.commit('someVariables/UPDATE_SHOW_CONFIG_RESET_TA', false)
    }

    return {
      avatarText,
      messageError,
      variante,
      dismissCountDown,
      dismissSecs,
      countDownChanged,
      showMessageAlert,
      hasError,
      onlyClose,
      reset,
      showLoading,
      etapaSelected,
      radioSelected,
      listOpciones,
      USER,
      ROLES,
      idConfig,
      saveDelete,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
.camp-activo {
  background: #00ff31;
  border-radius: 3px;
  padding: 6px;
  top: 5px;
  position: relative;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: bolder;
}
.camp-anterior {
  background: #ffee00;
  border-radius: 3px;
  padding: 6px;
  top: 5px;
  position: relative;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: bolder;
}
</style>
